import { CartAddEvent, CartGroupedSections } from '@theme/events';
document.querySelectorAll('.bloom-cart-offers__inner').forEach(container => {
  const slot = container.querySelector('[id^="reconvert-slot-"]');
  if (!slot) return;
  const sync = () => { container.hidden = slot.childElementCount === 0; };
  new MutationObserver(sync).observe(slot, { childList: true });
  sync();
});
document.addEventListener('change', event => {
  if (!event.target.matches('[data-picker-plan]')) return;
  const note = event.target.form.querySelector('[data-picker-renewal]');
  if (note) note.hidden = !event.target.value;
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-bloom-picker-add]')) return;
  event.preventDefault();
  if (form.dataset.busy) return;
  form.dataset.busy = 'true';
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[role="status"]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  error.hidden = true;
  try {
    const sections = [];
    document.dispatchEvent(new CartGroupedSections(sections));
    const body = new FormData(form);
    body.set('sections', [...new Set(sections)].slice(0, 5).join(','));
    body.set('sections_url', location.pathname);
    const response = await fetch(form.action + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || form.dataset.error);
    form.closest('dialog')?.close();
    document.dispatchEvent(new CartAddEvent(data, 'bloom-picker-cart', { source: 'bloom-picker-cart', itemCount: 1, variantId: body.get('id'), sections: data.sections }));
  } catch (failure) {
    error.textContent = failure.message || form.dataset.error;
    error.hidden = false;
  } finally {
    delete form.dataset.busy;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
